import React from 'react';
import { useIntl } from 'react-intl';
import CategoryHeading from '@fuww/library/src/CategoryHeading';
import { List } from '@fuww/library/src/List';
import withQuery from '../../../lib/withQuery';
import { useSiteContext } from '../../SiteContext';
import messages from '../../../lib/messages.json';
import NewsFeedListItem from '../../News/Article/NewsFeedListItem';
import articlesConnectionQuery
  from '../../../lib/queries/news/articlesConnectionQuery.graphql';
import {
  newsFeedImageConfigurations,
} from '../../../lib/imageConfigurations';
import { minimumPositiveValue } from '../../../lib/isPositiveSentiment';
import {
  ArticlesConnectionQuery,
  ArticlesConnectionQueryVariables,
  NewsArticleSorting,
} from '../../../lib/graphql/api/graphql';

const RelatedNews = withQuery(({
  data, variables,
}: {
  data: ArticlesConnectionQuery;
  variables: ArticlesConnectionQueryVariables;
}) => {
  const { edges } = data.universalNewsArticlesConnection;

  return (
    <List>
      {edges.map((edge, index: number) => {
        const { node } = { ...edge };

        return (
          <NewsFeedListItem
            article={node}
            variables={variables}
            isFirstImage={index === 0}
            key={node.id.toString()}
          />
        );
      })}
    </List>
  );
});

const RelatedNewsWithQuery = ({
  tagSlugs,
}: {
  tagSlugs: string[];
}) => {
  const intl = useIntl();
  const {
    newsboard,
  } = useSiteContext();

  const variables = {
    newsboard,
    pageviews: false,
    sort: NewsArticleSorting.INSERTED_AT,
    first: 3,
    imageConfigurations: newsFeedImageConfigurations,
    tagSlugs,
    minScores: [{
      name: 'positive',
      value: minimumPositiveValue,
    }],
  };

  return (
    <>
      <CategoryHeading>
        {intl.formatMessage(messages.relatedNews)}
      </CategoryHeading>
      <RelatedNews
        query={articlesConnectionQuery}
        variables={variables}
        errorMessage="Error loading related news"
      />
    </>
  );
};

export default RelatedNewsWithQuery;
